import React, { useEffect, useState } from 'react';

import Header from './components/Header';
import Footer from './components/footer/Footer';
import HeroHome from './components/HeroHome';
import FeatureSection from './components/FeatureSection';
import TestimonialsSection from './components/TestimonialsSection';
import DemoSection from './components/DemoSection';
import ActionSection from './components/action-section/ActionSection';
import QuestionSection from './components/QuestionSection';
import RoadMapSection from './components/RoadMapSection';
import borderImg from "./images/border.png";
import borderLineImg from "./images/border-line.png";
import MobileScreen from './components/mobile';

function Home() {
  const [width, setWidth] = useState(window.innerWidth);

  function handleWindowSizeChange() {
    setWidth(window.innerWidth);
  }
  useEffect(() => {
    window.addEventListener("resize", handleWindowSizeChange);
    return () => {
      window.removeEventListener("resize", handleWindowSizeChange);
    };
  }, []);
  const isMobile = width < 1024;
  if (isMobile) return <MobileScreen width={width} />;

  return (
    <div className="flex flex-col min-h-screen overflow-hidden">
      <Header />
      <main className="flex-grow">
       <HeroHome />
       <DemoSection/>
       <FeatureSection/>
       <div className="w-full relative flex center">
            <img
              src={borderImg}
              alt="border-bg "
            />
          </div>
       <TestimonialsSection />
       <section className="w-full relative flex justify-center">
            <img
              src={borderLineImg}
              alt="border-line-img"
            />
          </section>
       <QuestionSection />
       <div className="w-full relative flex center mb-0">
            <img
              src={borderImg}
              alt="border-img "
            />
          </div>
       <RoadMapSection />
       <ActionSection/>
      
      </main>
      <Footer />

    </div>
  );
}

export default Home;